module.exports = __webpack_public_path__ + "files/d7105ff286713f39fbe251ff40c3354a.png";